import React, { useEffect, useRef } from "react";
import { SvgComponent } from "@commons/Componentes/SvgComponent/SvgComponent";

const ALTO_MAXIMO = 200;

/**
 * La caja de escritura. Enter envía y Shift+Enter hace salto de línea, igual que en la
 * pantalla anterior, para no cambiarle el hábito a quien ya usaba el asistente.
 */
export const ChatComposer = ({ valor, onChange, onEnviar, ocupado, deshabilitado, motivo }) => {
  const ref = useRef(null);

  // El textarea crece con el texto hasta un tope y a partir de ahí hace scroll.
  useEffect(() => {
    const campo = ref.current;
    if (!campo) return;

    campo.style.height = "auto";
    campo.style.height = `${Math.min(campo.scrollHeight, ALTO_MAXIMO)}px`;
    campo.style.overflowY = campo.scrollHeight > ALTO_MAXIMO ? "auto" : "hidden";
  }, [valor]);

  useEffect(() => {
    if (!deshabilitado) ref.current?.focus();
  }, [deshabilitado]);

  const manejarTecla = (evento) => {
    if (evento.key === "Enter" && !evento.shiftKey) {
      evento.preventDefault();
      onEnviar();
    }
  };

  const puedeEnviar = !ocupado && !deshabilitado && valor.trim().length > 0;

  return (
    <div className="citrus-gpt-composer">
      <div className="citrus-gpt-composer__caja">
        <textarea
          ref={ref}
          rows={1}
          value={valor}
          disabled={deshabilitado}
          placeholder={deshabilitado ? motivo : "Pregunte algo sobre el ERP..."}
          aria-label="Escriba su pregunta"
          onChange={(evento) => onChange(evento.target.value)}
          onKeyDown={manejarTecla}
        />
        <button
          type="button"
          className="citrus-gpt-composer__enviar"
          onClick={onEnviar}
          disabled={!puedeEnviar}
          title="Enviar"
          aria-label="Enviar pregunta"
        >
          <SvgComponent iconName="send-message" width="18px" height="18px" fill="currentColor" />
        </button>
      </div>
      <p className="citrus-gpt-composer__pie">
        Enter envía, Shift + Enter agrega una línea. Las respuestas sin validar deben verificarse
        antes de aplicarlas.
      </p>
    </div>
  );
};
